import BackendService from './BackendService'

export default class StorageService extends BackendService {

  async getDownloadURL (fullPath: string) {
    const ref = this.$storage.ref().child(fullPath)
    return await ref.getDownloadURL().then(function(url: string) {
      return url
    }).catch(function(error: any) {
      console.log('Error in getDownloadURL', error)
      return false
    });
  }

  async listFiles (listRef: any) {
    return listRef.listAll().then(function(res: any) {
        return res.items.map((itemRef: any) => {
          const item: any = {};
          item.name = itemRef.name.replace(/\.[^/.]+$/, "")
          item.fullPath = itemRef.fullPath
          return item
        });
      }).catch(function(error: any) {
        console.error('Error in listFiles: ', error)
        return false
      });
  }

  async uploadFile (fullPath: string, file: any) {
    this.$storage.ref(fullPath).put(file)
      .then((snap: any) => {
        return snap;
      })
      .catch((error: any) => {
        console.log('Error in uploadFile: ', error)
        return false;
      })
  }

  async deleteFile (fullPath: string) {
    this.$storage
      .ref(fullPath)
      .delete()
      .then(() => {
        return true;
      })
      .catch((error: any) => {
        console.error('Error in deleteFile: ', error)
        return false;
      })
  }
}